module.exports = __webpack_public_path__ + "static/media/NoImage.17e32296.svg";